import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CookieConsentComponent } from './page/components/shared/cookie-consent/cookie-consent.component';
import { AppStateInterface } from './store/types';
import { Store } from '@ngrx/store';
import * as LanguageActions from '../app/store/language/actions';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
    providers: []
})
export class AppComponent {
  constructor(
    private _store: Store<AppStateInterface>,
    private _router: Router,
  ) {

  }

  ngOnInit(){
    const initialUrlChunks = this._router.url.split('/');
    if(initialUrlChunks && initialUrlChunks.length > 2 && ['en', 'de', 'fa', 'id'].includes(initialUrlChunks[-1])){
      this._store.dispatch(LanguageActions.setActiveLanguage({activeLanguage: initialUrlChunks[-1]}))
    }
  }
}
